import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/biometric-settings/',
    redirectTo: '/biometric-settings/sex',
  },
];

export default redirects;
